import React, { useState, useEffect } from "react";
import HalfArrow from "assets/images/half-arrow.svg";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import {
  errorCleanUp,
  signup,
  messageCleanUp,
} from "redux-store/auth/auth.slice";
import {
  error,
  loginSuccessMessage,
  activityInProcess,
} from "redux-store/auth/auth.selector";
import { useNavigate } from "react-router-dom";

const SignUpForm = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const loading = useSelector(activityInProcess);
  const [hospital, setHospital] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    phone: "",
    secret: "",
  });
  const [errMessages, setMessages] = useState({
    nameMessage: "",
    emailMessage: "",
    passwordMessage: "",
    secrectMessage: "",
  });
  //
  const signUpError = useSelector(error);
  const succesMessage = useSelector(loginSuccessMessage);
  useEffect(() => {
    dispatch(errorCleanUp());
    dispatch(messageCleanUp());
    if (succesMessage !== "") {
      let path = "signup";
      navigate(`/auth/enter-otp/${formData.email}/${path}`);
    }
  }, [succesMessage]);

  const onchange = (e: { target: { name: any; value: any } }) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email: string) => {
    // Regular expression pattern for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateFullName = (fullName: string) => {
    // Regular expression pattern for validating full name
    const fullNameRegex = /^[a-zA-Z ]+$/;
    return fullNameRegex.test(fullName);
  };

  const validatePassword = (password: string) => {
    // Regular expression pattern for password validation
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
    return passwordRegex.test(password);
  };

  const onSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const { fullName, email, password, secret } = formData;
    if (hospital && secret !== process.env.REACT_APP_HOSPITAL_SECRET) {
      setMessages({
        ...errMessages,
        secrectMessage: "Invalid hospital secret",
      });
      return;
    }
    let validEmail = true;
    let validName = true;
    let validPass = true;

    if (!validateFullName(fullName)) {
      validName = false;
    }

    if (!validateEmail(email)) {
      validEmail = false;
    }

    if (!validatePassword(password)) {
      validPass = false;
    }

    setMessages({
      ...errMessages,
      emailMessage: validEmail ? "" : "Invalid Email",
      nameMessage: validName ? "" : "Invalid username",
      secrectMessage: "",
      passwordMessage: validPass
        ? ""
        : "Password must have at least 8 digits length, 1 character, 1 number",
    });
    if (validEmail && validName && validPass) {
      dispatch(errorCleanUp());
      if (succesMessage !== "") {
        dispatch(messageCleanUp());
      }
      dispatch(signup({ user: formData, hospital: hospital }));
    }
  };

  return (
    <div className="tw-w-[80%] lg:tw-w-[70%] tw-mx-auto tw-py-10 tw-bg-[#ffffff] tw-flex tw-items-center tw-justify-center tw-rounded-[1.9375rem] shadow-small lg:shadow-large lg:tw-rounded-[1.25rem] ">
      <div className="tw-w-[80%] tw-flex tw-flex-col tw-gap-4">
        {/* form 2nd div */}
        <div className="tw-w-full">
          <form>
            <div className="tw-flex tw-flex-col tw-gap-4 tw-mb-2">
              <div className="tw-flex tw-flex-col tw-gap-2">
                <label className="tw-text-[0.75rem] tw-font-light lg:tw-text-[1rem] lg:tw-font-bold">
                  Full Name or Hospital Name
                </label>
                <input
                  type="text"
                  className="tw-rounded tw-p-2 focus:tw-outline-none tw-bg-[#FFF6F4] tw-text-[0.625rem]  lg:tw-text-[0.875rem] tw-font-light"
                  placeholder="Full Name or Hospital Name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={(e) => onchange(e)}
                />
                <span className=" tw-text-xs tw-text-red-500">
                  {errMessages.nameMessage}
                </span>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-2">
                <label className="tw-text-[0.75rem] tw-font-light lg:tw-text-[1rem] lg:tw-font-bold">
                  Personal Email or Hospital Email
                </label>
                <input
                  type="email"
                  className="tw-rounded tw-p-2 focus:tw-outline-none tw-bg-[#FFF6F4] tw-text-[0.625rem]  lg:tw-text-[0.875rem] tw-font-light"
                  placeholder="Personal Email or Hospital Email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => onchange(e)}
                />
                <span className="tw-text-xs tw-text-red-500">
                  {errMessages.emailMessage}
                </span>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-2">
                <div className="tw-flex tw-items-center tw-justify-between">
                  <label className="tw-text-[0.75rem] tw-font-light lg:tw-text-[1rem] lg:tw-font-bold">
                    Password
                  </label>
                </div>
                <input
                  type="password"
                  className="tw-rounded tw-p-2 focus:tw-outline-none tw-bg-[#FFF6F4] tw-text-[0.625rem]  lg:tw-text-[0.875rem] tw-font-light"
                  placeholder="Create Password"
                  name="password"
                  value={formData.password}
                  onChange={(e) => onchange(e)}
                />
                <span className=" tw-text-xs tw-text-red-500">
                  {errMessages.passwordMessage}
                </span>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-2">
                <div className="tw-flex tw-items-center tw-justify-between">
                  <label className="tw-text-[0.75rem] tw-font-light lg:tw-text-[1rem] lg:tw-font-bold">
                    Phone Number
                  </label>
                </div>
                <input
                  type="text"
                  className="tw-rounded tw-p-2 focus:tw-outline-none tw-bg-[#FFF6F4] tw-text-[0.625rem]  lg:tw-text-[0.875rem] tw-font-light"
                  placeholder="Phone Number"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => onchange(e)}
                />
                <span className=" tw-text-xs tw-text-red-500">
                  {errMessages.passwordMessage}
                </span>
              </div>
              {hospital && (
                <div className="tw-flex tw-flex-col tw-gap-2">
                  <div className="tw-flex tw-items-center tw-justify-between">
                    <label className="tw-text-[0.75rem] tw-font-light lg:tw-text-[1rem] lg:tw-font-bold">
                      Hospital Code
                    </label>
                  </div>
                  <input
                    type="text"
                    className="tw-rounded tw-p-2 focus:tw-outline-none tw-bg-[#FFF6F4] tw-text-[0.625rem]  lg:tw-text-[0.875rem] tw-font-light"
                    placeholder="Secret Code"
                    name="secret"
                    value={formData.secret}
                    onChange={(e) => onchange(e)}
                  />
                  <span className=" tw-text-xs tw-text-red-500">
                    {errMessages.secrectMessage}
                  </span>
                </div>
              )}
              <div className="tw-flex tw-cursor-pointer tw-gap-x-3 tw-items-center">
                <input
                  type="checkbox"
                  name="isHospital"
                  id="isHospital"
                  checked={hospital}
                  onChange={(e) => setHospital(e.target.checked)}
                />
                <label htmlFor="isHospital">Register as hospital</label>
              </div>
              <div className="tw-flex tw-items-center tw-justify-center ">
                {/* <button className="tw-flex tw-items-center tw-space-x-1 tw-rounded-full tw-bg-[#FF7B6D] tw-mt-2 tw-py-2 tw-px-3 tw-text-[0.875rem] tw-font-light lg:tw-text-base lg:tw-font-bold tw-text-[#FFFFFF] tw-uppercase"> */}
                <div className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-2">
                  <span className="tw-text-xs tw-text-red-500">
                    {signUpError.message !== "" ? signUpError.message : ""}
                  </span>
                  <button
                    className="tw-w-[100%] tw-flex tw-items-center tw-gap-3 tw-rounded-full tw-bg-[#FF7B6D] tw-py-1.5 tw-px-4 tw-text-[0.875rem] lg:tw-text-base tw-font-semibold tw-text-[#FFFFFF] tw-uppercase"
                    type="submit"
                    onClick={(e) => {
                      onSubmit(e);
                    }}
                  >
                    <span className=" tw-text-center tw-m-auto tw-flex tw-gap-2">
                      {loading ? "Registering..." : "Create Account"}
                      <img src={HalfArrow} alt="arrow" />
                    </span>
                  </button>
                  <button
                    className=" tw-w-[100%] tw-flex tw-items-center tw-gap-3 tw-rounded-full tw-bg-slate-200 tw-text-[#FF7B6D] tw-py-1.5 tw-px-3 tw-text-[0.875rem] lg:tw-text-base tw-font-semibold tw-uppercase"
                    onClick={(e) => {
                      navigate("/");
                    }}
                  >
                    <span className=" tw-text-center tw-m-auto tw-flex tw-gap-2">
                      Login
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUpForm;
